import React from 'react';
import "../../pages/hardware-attendances/css/status-cell.css"

const PendCellRenderer = ({data}) => {
    const multiway = data.pend_multiway ? 'Multiway' : '';
    const client = data.pend_client ? 'Cliente' : '';
    const terceiros = data.pend_terceiros ? 'Terceiros' : '';
    const terceirosString = data.pend_terceiros ? 'Multiway subcontratado' : '';

    const pend = [
        multiway,
        client && (multiway ? " | " : "") + client,
        terceirosString && (multiway || client ? " | " : "") + terceirosString,
    ].filter(Boolean).join('');

    if (multiway || client || terceiros) {
        return (
            <div className={`well-status well ${multiway} ${client} ${terceiros}`}>
                {pend}
            </div>
        );
    }
};

export default PendCellRenderer;